export default class Secure{

    /**
     * SHA256処理を行う。
     * @param data 
     * @returns 
     */
    public static SHA256(data:string):JQuery.Deferred<any, any, any>
    {
        let deffered = $.Deferred();

        const buff = new Uint8Array([].map.call(data, (c) => c.charCodeAt(0))).buffer;
        crypto.subtle.digest('SHA-256', buff).then(digest=>{
            let strRet =  [].map.call(new Uint8Array(digest), x => ('00' + x.toString(16)).slice(-2)).join('');
            deffered.resolve(strRet);
        }, reason=>{
            deffered.resolve("Error");
        });

        return deffered;
    }

}